export const PAGE_PATHS = {
  SIGNUP: "/onboard-user",
  SIGNUP_SELF: "/onboard-user-self",
  MOCK_CSC_AUTH_PAGE: "/mock-csc-auth",
  ERROR: "/error",
  ONBOARDING_SUCCESS: "/onboarding-success",
  DEFAULT: "*",
  DEFAULT_NAVIGABLE: "/",
};
